import { render, staticRenderFns } from "./SkupTema2Base.vue?vue&type=template&id=cf7da882&scoped=true&"
import script from "./SkupTema2Base.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7da882",
  null
  
)

export default component.exports